import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import PopularComics from './components/PopularComics';
import ArticleList from './components/ArticleList';
import RecentUpdates from './components/RecentUpdates';

export default function Home() {
  useEffect(() => {
    document.title = '韩漫网站免费阅读看漫画下拉双男主-好看的漫画韩漫免费看-韩漫免费无遮漫画';
  }, []);

  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <PopularComics />
          <RecentUpdates />
          <ArticleList />

          <section className="py-14 bg-primary-500">
            <div className="max-w-[1280px] mx-auto px-4 md:px-6 text-center">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50">随时随地，免费畅享韩漫</h2>
              <p className="mt-3 text-background-50/80 text-sm max-w-xl mx-auto">
                韩漫网站支持免费阅读看漫画下拉双男主，好看的漫画韩漫免费看，汇集韩漫免费无遮漫画资源
              </p>
              <a
                href="/category/shuang-nanzhu"
                className="inline-block mt-6 px-8 py-3 rounded-lg bg-background-50 text-primary-600 font-semibold text-sm hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                立即探索
              </a>
            </div>
          </section>
        </main>
        <Footer />
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '韩漫网站免费阅读看漫画下拉双男主-好看的漫画韩漫免费看',
            description: '韩漫网站支持免费阅读看漫画下拉双男主，好看的漫画韩漫免费看，并汇集韩漫免费无遮漫画资源。',
            url: 'https://www.example.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '韩漫免费阅读',
              url: 'https://www.example.com/',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [{
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://www.example.com/',
              }],
            },
          }),
        }}
      />
    </>
  );
}